import { render, staticRenderFns } from "./GlobalTrends.vue?vue&type=template&id=db1ada86&scoped=true"
import script from "./GlobalTrends.vue?vue&type=script&lang=js"
export * from "./GlobalTrends.vue?vue&type=script&lang=js"
import style0 from "./GlobalTrends.vue?vue&type=style&index=0&id=db1ada86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1ada86",
  null
  
)

export default component.exports